import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CrisisBanner from "./components/CrisisBanner";
import Home from "./pages/Home";
import Story from "./pages/Story";
import Companion from "./pages/Companion";
import Speaking from "./pages/Speaking";
import Courses from "./pages/Courses";
import MiniCourse from "./pages/MiniCourse";
import Help from "./pages/Help";
import Resources from "./pages/Resources";
import Quiz from "./pages/Quiz";
import FreeTools from "./pages/FreeTools";
import Unsubscribe from "./pages/Unsubscribe";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Course from "./pages/Course";
import CourseSuccess from "./pages/CourseSuccess";
import CourseLogin from "./pages/CourseLogin";
import CourseDashboard from "./pages/CourseDashboard";
import CourseLesson from "./pages/CourseLesson";
import Watch from "./pages/Watch";
import Journal from "./pages/Journal";

// Hide public chrome on admin routes and the standalone unsubscribe page
const Shell = ({ children }) => {
    const { pathname } = useLocation();
    const isChromeHidden =
        pathname.startsWith("/admin") ||
        pathname.startsWith("/unsubscribe") ||
        pathname.startsWith("/course/success") ||
        pathname.startsWith("/course/login") ||
        pathname.startsWith("/course/dashboard") ||
        pathname.startsWith("/course/lesson");
    return (
        <>
            {!isChromeHidden && <Navbar />}
            <main className="min-h-[60vh]">{children}</main>
            {!isChromeHidden && <Footer />}
            {!isChromeHidden && <CrisisBanner />}
        </>
    );
};

function App() {
    return (
        <div className="App bg-black text-white" data-testid="app-root">
            <BrowserRouter>
                <Shell>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/story" element={<Story />} />
                        <Route path="/companion" element={<Companion />} />
                        <Route path="/speaking" element={<Speaking />} />
                        <Route path="/courses" element={<Courses />} />
                        <Route path="/daily-battle-drill" element={<MiniCourse />} />
                        <Route path="/journal" element={<Journal />} />
                        <Route path="/help" element={<Help />} />
                        <Route path="/resources" element={<Resources title="Free Tools for the Fight" />} />
                        <Route path="/quiz" element={<Quiz />} />
                        <Route path="/free-tools" element={<FreeTools />} />
                        <Route path="/watch/:videoId" element={<Watch />} />
                        <Route path="/unsubscribe" element={<Unsubscribe />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                        <Route path="/course" element={<Course />} />
                        <Route path="/course/success" element={<CourseSuccess />} />
                        <Route path="/course/login" element={<CourseLogin />} />
                        <Route path="/course/dashboard" element={<CourseDashboard />} />
                        <Route path="/course/lesson/:moduleId/:lessonId" element={<CourseLesson />} />
                    </Routes>
                </Shell>
                <Toaster
                    theme="dark"
                    position="top-center"
                    toastOptions={{
                        style: {
                            background: "#0a0a0a",
                            border: "1px solid #B91C1C",
                            color: "#fff",
                            borderRadius: 0,
                            fontFamily: "Inter, sans-serif",
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
